import PropTypes from 'prop-types';
import {isNil} from 'ramda';
/* eslint-disable no-unused-vars */
import React, {Component} from 'react';
import {withRouter} from 'react-router';
import styled from 'styled-components';
import {loadActivities, updateActivityType} from '../../api';
import {activityScoringMetadata} from '../../util/ActivityMetadata';

const Wrapper = styled.div`
  height: calc(100vh);
  position: unset;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
`;

class Activities extends Component {
  constructor() {
    super();
    
    this.state = {
      activities: [],
      isLoading: false
    };
  }
  
  componentDidMount() {
    return loadActivities()
      .then(response => this.setState({activities: response.data}));
  }
  
  calculateTotal = (activity) => {
    if (isNil(activity) || isNil(activity.properties)) return 0;
    
    const metadata = activityScoringMetadata[activity.activity_type];
    const startingValue = metadata.start || 0;
    
    return activity.properties.reduce((total, property) => {
      const key = property.property_key;
      const value = property.property_value;
      const multiplier = isNil(metadata) || isNil(metadata.multipliers) ? 1 : metadata.multipliers[key];
      
      let calculated = total + (value * multiplier);
      const {min, max} = metadata;
      if (!isNil(min) && calculated < min) {
        calculated = min;
      } else if (!isNil(max) && calculated > max) {
        calculated = max;
      }
      return calculated;
    }, startingValue);
  };
  
  onChangeActivity = (type, propertyKey, propertyValue, defaultActivity) => {
    const {activities} = this.state;
    
    const activity = activities.find(a => a.activity_type === type) || defaultActivity;
    activity.properties = activity.properties
      .filter(p => p.property_key !== propertyKey)
      .concat({
        property_key: propertyKey,
        property_value: propertyValue
      });
    activity.total = this.calculateTotal(activity);
    
    const updatedActivities = activities
      .filter(a => a.activity_type !== type)
      .concat(activity);
    
    this.setState({activities: updatedActivities});
  };
  
  onUpdateActivity = (type, defaultActivity) => {
    const {router} = this.props;
    const {activities} = this.state;
    const stateActivity = activities.find(a => a.activity_type === type);

    // if there is no activity at this point, then the user probably navigated to an activity screen but never +/- anything,
    // we still need to log an activity in this case in order to allow earning a point for the day even if you didn't
    // earn points in this specific activity.
    const activity = stateActivity || defaultActivity;

    this.setState({isLoading: true});
    return updateActivityType(type, {activity})
      .then(response => response.data)
      .then(() => this.setState({isLoading: false}))
      .then(() => router.push('/dashboard'));
  };
  
  render() {
    const {children, router} = this.props;
    const {activities, isLoading} = this.state;
    
    if (isNil(children)) {
      router.push('/dashboard');
      return null;
    }

    const bodyComponent = isNil(activities) ? null : React.cloneElement(children, {
      activities: activities,
      onUpdateActivity: this.onUpdateActivity,
      onChangeActivity: this.onChangeActivity,
      isLoading: isLoading
    });
    
    return (
      <Wrapper>
        {bodyComponent}
      </Wrapper>
    );
  }
}

Activities.propTypes = {
  children: PropTypes.any,
  router: PropTypes.object.isRequired
};

export default withRouter(Activities);



// WEBPACK FOOTER //
// ./src/pages/Activities/Activities.js